// frontend/src/components/homepage/Arrow.js
//
// The one inline arrow every "go somewhere" link on the homepage ends with -
// the hero's primary CTA, the feature tiles' "read more", the blog cards, the
// two CTA buttons.
//
// AN SVG, NOT THE ARROW CHARACTER. The prototype writes a literal U+2190 / U+2192
// and lets the font draw it. Heebo is self-hosted here in unicode-range
// subsets, and neither arrow sits in `hebrew` or `latin`: the two characters
// alone made every visit fetch the `symbols` and `math` faces (38 KB) for
// six glyphs. A stroked path in `currentColor` is the same shape at the same
// optical size, fetches nothing, and takes the same hover nudge - the callers
// keep their per-site class (`hl-arr`, `hl-cta-arr`, `hl-blog-rm-arr`, ...) and
// the stylesheets' `transform` rules move the SVG exactly as they moved the
// glyph. `.hl-arrow` (homepage.css) sizes it to the surrounding text.
//
// Decorative: the text beside it already says where the link goes.

import React from "react";

/**
 * @param {object} props
 * @param {"left"|"right"} [props.direction] where the arrow points. A Hebrew
 *   page points LEFT (forward in RTL), the English one RIGHT.
 * @param {string} [props.className] the caller's hover-nudge class.
 */
export default function Arrow({ direction = "left", className }) {
  // Two explicit paths rather than one mirrored with a transform: the hover
  // nudge the callers' CSS applies IS a transform, and an inline one here
  // would beat it. The shaft runs the full glyph width like the font's, and
  // the head is two strokes.
  const d = direction === "left" ? "M20 12H5M11 6l-6 6 6 6" : "M4 12h15M13 6l6 6-6 6";
  return (
    <svg
      className={className ? `hl-arrow ${className}` : "hl-arrow"}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      data-direction={direction}
    >
      <path d={d} />
    </svg>
  );
}
